import { render, staticRenderFns } from "./UserSugSelect.vue?vue&type=template&id=290f00c2&scoped=true&"
import script from "./UserSugSelect.vue?vue&type=script&lang=js&"
export * from "./UserSugSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserSugSelect.vue?vue&type=style&index=0&id=290f00c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290f00c2",
  null
  
)

export default component.exports